import { render } from "./TransitionHeight.vue?vue&type=template&id=4b40a306"
import script from "./TransitionHeight.vue?vue&type=script&lang=ts"
export * from "./TransitionHeight.vue?vue&type=script&lang=ts"
script.render = render

export default script